<script lang="ts">
	import CounterDigit from '$lib/home/CounterDigit.svelte';
	import { pad } from '$lib/util/util';
	import { fade } from 'svelte/transition';

	export let name: string;
	export let time: number;
	export let color: string = 'text-fx-gradient-22';
	export let size: string = 'text-xl';
	export let fontWeight: string = 'font-semibold';
	$: digits = pad(time, 2).split('');
</script>

<div class="{color} {size} {fontWeight}">
	{time}{name}
</div>
